import styles from './index.scss'

const IconTitle = (props: {
  itemStyles?: React.CSSProperties,
  hiddenName?: boolean,
  onClick?: () => void,
  src?: string,
  title?: string,
}) => {
  return (
    <div className={styles['dp-business-toolbar-item']} style={props?.itemStyles} onClick={props?.onClick}>
      <img src={props?.src} alt={props?.title} />
      {!props?.hiddenName && <div className={styles['dp-business-toolbar-item--title']}>{props?.title}</div>}
    </div>
  )
}

export default IconTitle
